import { z } from 'zod';

import { DataTypeOfZodSchema } from '@rover/kibble/forms';
import { getWordCount } from '@rover/utilities/wordCount';

export const MAX_CHARACTER_COUNT = 35;
export const MIN_WORD_COUNT = 25;

export const dogCareDetailsSchema = z.object({
  headline: z
    .string()
    .trim()
    .min(1, `This field is required.`)
    .max(MAX_CHARACTER_COUNT, `Please enter no more than ${MAX_CHARACTER_COUNT} characters.`),
  experience: z.string().refine((val) => (getWordCount(val) ?? 0) >= MIN_WORD_COUNT, {
    message: `Please write at least ${MIN_WORD_COUNT} words.`,
  }),
  yearsOfExperience: z.coerce
    .number()
    .int('Enter a whole number.')
    .min(1, 'You must have experience caring for pets to offer pet care through Rover.')
    .max(100),
  imageUrl: z.string().min(1, 'Profile photo is required.'),
});

export type DogCareDetailsFormData = DataTypeOfZodSchema<typeof dogCareDetailsSchema>;
